import { Column, Modal, Table } from "@appkit4/react-components";
import { useEffect, useRef, useState } from "react";
import { Button } from "../../components/ReadonlyAwareInputs";
import { formatDate } from "../../utils/dateProcessor";
import {
  formatReturnStatus,
  getNewReturnStatus,
  getPeriodsSplit,
} from "./GroupPoAUtils";

const OpenPeriodModal = ({
  visible,
  setVisible,
  periodIndexToOpen,
  tableData,
  updateTableData,
}) => {
  const hasNextPeriods = Boolean(tableData[periodIndexToOpen + 1]);
  const [submittedPeriods, setSubmittedPeriods] = useState([]);
  const periodDates = useRef();

  useEffect(() => {
    const { periodsToReopen } = getPeriodsSplit(tableData, periodIndexToOpen);
    const submittedPeriods = periodsToReopen.filter(
      (period) => period?.return_status?.isSubmitted,
    );

    const { period_start, period_end } = tableData?.[periodIndexToOpen] ?? {};
    periodDates.current = `${formatDate(period_start)} - ${formatDate(period_end)}`;

    setSubmittedPeriods(submittedPeriods);
  }, [visible]);

  const reopen = (index) => {
    let { periodsToSkip, periodsToReopen } = getPeriodsSplit(tableData, index);

    periodsToReopen = periodsToReopen.map((period) => ({
      ...period,
      lastCompletedPoACalcs: null,
      return_status: {
        ...period?.return_status,
        ...getNewReturnStatus(period),
      },
    }));

    updateTableData([...periodsToSkip, ...periodsToReopen]);
    handleClose();
  };

  const handleClose = () => {
    setVisible(false);
    setSubmittedPeriods([]);
  };

  return (
    <Modal
      visible={visible}
      initialFocus={false}
      title={`Open period ${periodDates.current}`}
      ariaLabel={"Open period"}
      maskCloseable={false}
      onCancel={handleClose}
      modalStyle={{ width: "40rem" }}
      footerStyle={{ paddingTop: "8px", height: "64px" }}
      footer={
        <>
          <Button neverReadonly kind="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => reopen(periodIndexToOpen)}>
            Open Period
          </Button>
        </>
      }
    >
      {hasNextPeriods && (
        <p className="bold-text" style={{ color: "#E0301E" }}>
          Warning: any subsequent periods will also be reopened.
        </p>
      )}
      {submittedPeriods.length > 0 ? (
        <>
          <p className="bold-text">
            Opening the following periods will treat them as revised. Please
            contact an admin if this should not be the case.
          </p>
          <Table
            style={{ marginTop: "16px" }}
            originalData={submittedPeriods}
            hasTitle
            striped
          >
            <Column
              field="period_start"
              renderCell={(period) => formatDate(period?.period_start)}
            >
              Period Start
            </Column>
            <Column
              field="period_end"
              renderCell={(period) => formatDate(period?.period_end)}
            >
              Period End
            </Column>
            <Column
              field="return_status"
              renderCell={(period) => formatReturnStatus(period)}
            >
              Return Status
            </Column>
          </Table>
        </>
      ) : (
        <p className="bold-text">No submitted periods to open as revised.</p>
      )}
    </Modal>
  );
};

export default OpenPeriodModal;
